<template>
    <el-dialog
        style="padding: 0 20px 20px 20px !important;"
        width="80%"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
    >
        <el-form ref="ruleForm" :inline="true" class="query-form" size="mini" :model="query">
            <el-form-item label="店铺名称：" class="query-form-item">
                <el-input
                    v-model="query.shop_name"
                    placeholder="请输入店铺名称"
                    style="width: 200px;"
                ></el-input>
            </el-form-item>

            <el-form-item>
                <el-button icon="el-icon-refresh" @click="onReset"></el-button>
                <el-button icon="el-icon-search" type="primary" @click="onSubmit">查询</el-button>
                <el-button icon="el-icon-plus" type="success" @click="addNameModal = true">添加</el-button>

            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :data="list"
            size="mini"
            ref="multipleTable"
            border
            style="width: 100%"
        >
            <el-table-column label="ID" align="center" width="150">
                <template slot-scope="scope">
                    <div>{{ scope.row.id }}</div>
                </template>
            </el-table-column>

            <el-table-column label="店铺名称" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.shop_name }}</div>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="150" align="center">
                <template slot-scope="scope">
                    <el-button
                        style="margin: 5px 0 5px 10px"
                        type="danger"
                        size="mini"
                        @click="delItemName(scope.row)"
                    >删除
                    </el-button
                    >
                </template>
            </el-table-column>
        </el-table>
        <el-row type="flex" justify="end">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-size="query.limit"
                :page-sizes="[10, 50, 100]"
                :total="query.total"
                background
                style="float: right;margin-top: 10px; margin-bottom: 5px"
                layout="total, sizes, prev, pager, next"
            >
            </el-pagination>
        </el-row>
        <el-dialog style="padding: 0 20px 20px 20px !important;" width="30%" center title="错误信息" v-if="errorInfoShow"
                   :visible.sync="errorInfoShow" append-to-body>
            <span style="color: red">错误内容：</span>
            <span>{{errorMsg}}</span>
            <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="errorInfoShow = false">关 闭</el-button>
			</span>
        </el-dialog>

        <el-dialog width="30%" center title="添加店铺名称" :visible.sync="addNameModal" append-to-body>
            <el-form :inline="true" class="query-form" size="mini">

                <el-form-item label="店铺名称：" class="query-form-item" style="margin: 20px 0 10px">
                    <el-input
                        v-model="add_shop_name"
                        placeholder="请输入店铺名称"
                        style="width: 200px;"
                    ></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer">
				<el-button type="primary" @click="onAdd" size="mini">取 消</el-button>
				<el-button type="primary" @click="onAdd(true)" size="mini">添 加</el-button>
			</span>
        </el-dialog>
    </el-dialog>
</template>

<script>
    import * as api from '@/api/Product/Product'
    import {downloadFileUrl} from '@/utils/method'

    export default {
        name: 'uploadFileListDialog',
        components: {},
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                add_shop_name: '',
                addNameModal: false,
                errorInfoShow: false,
                tableHeight: null,
                query: {
                    page: 1,
                    limit: 10,
                    state: '',
                    shop_name: '',
                    asgin: '',
                    ad_portfolio_name: '',
                    type: 'SB',
                },
                loading: false,
                errorMsg: '',
                currentId: '',
                ctrl: {
                    addRecordDialogVisible: false
                },
                list: [],
                rules: {
                    asin: [
                        {
                            required: true,
                            message: '请输入ASIN',
                            trigger: 'blur'
                        }
                    ],
                    state: [
                        {
                            required: true,
                            message: '请输入国家',
                            trigger: 'blur'
                        }
                    ],
                    ad_portfolio_name: [
                        {
                            required: true,
                            message: '请输入广告组合名称',
                            trigger: 'blur'
                        }
                    ],
                    type: [
                        {
                            required: true,
                            message: '请选择广告组类型',
                            trigger: 'blur'
                        }
                    ]
                }
            }
        },
        watch: {
            'visible': {
                handler(flag) {
                    flag && this.getList()
                }
            }
        },
        methods: {
            //查询
            onSubmit() {
                this.query.page = 1
                this.getList()
            },
            onAdd(flag) {
                if (flag) {
                    api.shop_name_add({shop_name: this.add_shop_name}).then((res) => {
                        if (res.success) {
                            this.$message.success('添加成功')
                            this.getList()
                        } else {
                            this.$message.success(res.message)
                        }
                    })
                }
                this.add_shop_name = ''
                this.addNameModal = false
            },
            delItemName(data) {
                this.$confirm('确认删除该店铺名称吗?', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.shop_name_delete({id: data.id}).then(() => {
                        this.$message.success('删除成功')
                        this.getList()
                    })
                })
            },
            onReset() {
                this.$set(this, 'query', {type: 'SB'})
                this.query.page = 1
                this.query.limit = 20
                this.getList()
            },
            searchForm() {
                this.getList()
            },
            showErrorInfo(info) {
                this.errorInfoShow = true
                this.errorMsg = info.err_smg
            },
            getList() {
                this.loading = true
                api.shop_name_index(this.query).then(res => {
                    if (res.code === 0) {
                        this.list = res.data.list
                        this.query.total = res.data.total
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.message
                        })
                    }
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            },
            // 关闭弹窗
            handleClose(isshow = false) {
                this.$emit('close-callback', isshow)
            },
            addRecords() {
                this.ctrl.addRecordDialogVisible = true
            },
            delete_records(data) {
                this.$confirm('确认删除该记录吗?', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.out_three_page_delete({id: data.id}).then(() => {
                        this.$message.success('删除成功')
                        this.getList()
                    })
                })
            },
            closeCllback() {
                this.ctrl.addRecordDialogVisible = false
            },
            //分页
            handleCurrentChange(val) {
                this.query.page = val
                this.getList()
            },
            handleSizeChange(val) {
                this.query.limit = val
                this.getList()
            },
            downFile(path) {
                if (!path) {
                    return this.$message({type: 'error', message: '无法下载！'})
                }
                downloadFileUrl(path)
            },
        }
    }
</script>

<style type="text/scss" lang="scss" scoped>
    /deep/ .el-card__header {
        padding: 14px 20px !important;
    }

    /deep/ .el-tabs__content {
        overflow: visible !important;
    }

    /deep/ .el-card {
        overflow: visible !important;
    }

    /deep/ .el-dialog__body {
        padding: 0px 20px 20px 20px !important;
    }

    .mini_div .el-button--mini {
        padding: 5px 5px !important;
    }

    /deep/ .el-table__expanded-cell {
        padding: 0 0 !important;
    }
</style>
